<template>
<div>
  <navigation></navigation>
  <expose-list :items="exposeList"></expose-list>
</div>
</template>

<script>
import Navigation from "./Navigation";
import ExposeList from "./ExposeList";

export default {
  name: 'ExposeListContainer',

  components: {
    Navigation,
    ExposeList
  },

  computed: {
    exposeList() {
      return this.$store.state.expose.list;
    }
  },

  created() {
    this.$store.dispatch("expose/loadAll");
  }
};
</script>
